export default __webpack_public_path__ + "static/media/fade.c82d0a0a.png";